const required = ['VITE_API_BASE_URL', 'VITE_APP_ENV', 'VITE_APP_NAME'] as const;

function validateEnv(): void {
  const missing = required.filter((key) => !import.meta.env[key]);
  if (missing.length > 0) {
    throw new Error(
      `[GarageWale ERP] Missing required env variables: ${missing.join(', ')}\n` +
        'Copy .env.example to .env and fill in the values.',
    );
  }
}

validateEnv();

export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  APP_ENV: import.meta.env.VITE_APP_ENV,
  APP_NAME: import.meta.env.VITE_APP_NAME,
  IS_DEV: import.meta.env.VITE_APP_ENV === 'development',
  IS_PROD: import.meta.env.VITE_APP_ENV === 'production',
} as const;
